var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCrown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 19h13a1 1 0 0 1 0 2h-13a1 1 0 0 1 0-2zM21.775 7.5c-.952 0-1.725.756-1.725 1.688 0 .25.058.481.158.696l-2.602 1.525a1.162 1.162 0 0 1-1.588-.407l-2.93-5.014c.385-.31.637-.773.637-1.3C13.725 3.756 12.952 3 12 3c-.952 0-1.725.756-1.725 1.688 0 .527.252.99.636 1.3l-2.929 5.014a1.163 1.163 0 0 1-1.588.407L3.795 9.884c.098-.211.159-.447.159-.697 0-.931-.773-1.687-1.725-1.687C1.276 7.5.5 8.256.5 9.188c0 .931.773 1.687 1.725 1.687a1.8 1.8 0 0 0 .277-.028L5.1 17.625h13.8l2.598-6.778a1.8 1.8 0 0 0 .277.028c.952 0 1.725-.756 1.725-1.688 0-.931-.773-1.687-1.725-1.687z",
    id: "v1ci5444da"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "k3jgr5j8mb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#v1ci5444da"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFD044",
    xlinkHref: "#v1ci5444da"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC023",
    mask: "url(#k3jgr5j8mb)",
    d: "m-2 0 24 24H-2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCrown);
export default __webpack_public_path__ + "static/media/icon-crown.a3dfd666.svg";
export { ForwardRef as ReactComponent };